// Mock data for ABR Barbearia

export const services = [
  {
    id: 1,
    name: 'Corte Masculino',
    description: 'Corte moderno e personalizado de acordo com seu estilo e formato do rosto.',
    image: 'https://customer-assets.emergentagent.com/job_barbeiros-jundiai/artifacts/21g2cpdc_7339a298-80e2-4de7-ac11-8a268f5e19b5.png',
    price: 'R$ 60',
    highlight: false
  },
  {
    id: 2,
    name: 'Barba com Toalha Quente',
    description: 'Design de barba com toalha quente, produtos premium e acabamento perfeito.',
    image: 'https://customer-assets.emergentagent.com/job_barbeiros-jundiai/artifacts/3wblfhyu_efb17e44-c48f-4931-a4e4-a26ed44a67bc.png',
    price: 'R$ 60',
    highlight: false
  },
  {
    id: 3,
    name: 'Corte + Barba',
    description: 'Combo completo: corte de cabelo e barba para uma transformação total.',
    image: 'https://customer-assets.emergentagent.com/job_barbeiros-jundiai/artifacts/6behd62l_b3030012-cd21-4621-ab71-1fdf567d9dd3.png',
    price: 'R$ 120',
    highlight: true
  },
  {
    id: 4,
    name: 'Sobrancelha',
    description: 'Design e alinhamento de sobrancelhas para um olhar mais marcante.',
    image: 'https://customer-assets.emergentagent.com/job_barbeiros-jundiai/artifacts/ns961ld6_80037069-03b6-4a95-bc40-d07de85ddf84.png',
    price: 'R$ 20',
    highlight: false
  },
  {
    id: 5,
    name: 'Depilação Nasal',
    description: 'Remoção de pelos nasais com técnica profissional e indolor.',
    image: 'https://customer-assets.emergentagent.com/job_barbeiros-jundiai/artifacts/kp3zrsbz_44293d1f-39d7-490e-b598-1d47d8ecb4f2.png',
    price: 'R$ 25',
    highlight: false
  },
  {
    id: 6,
    name: 'Selagem / Progressiva',
    description: 'Tratamento capilar para alisar e dar mais vida aos seus cabelos.',
    image: 'https://customer-assets.emergentagent.com/job_barbeiros-jundiai/artifacts/q0e4bg3e_ca940064-999d-4712-8f90-4d2e962230f7.png',
    price: 'R$ 100',
    highlight: false
  },
  {
    id: 7,
    name: 'Corte Infantil',
    description: 'Atendimento especializado para crianças com todo cuidado e paciência.',
    image: 'https://customer-assets.emergentagent.com/job_barbeiros-jundiai/artifacts/9xus2mom_6f36fa97-2232-42fe-81ec-9353c669f757.png',
    price: 'R$ 60',
    highlight: false
  }
];

export const stats = [
  { id: 1, value: 5000, suffix: '+', label: 'Clientes atendidos' },
  { id: 2, value: 5, suffix: '', label: 'Nota no Google', decimal: true },
  { id: 3, value: 7, suffix: '', label: 'Serviços premium' },
  { id: 4, value: 100, suffix: '%', label: 'Satisfação garantida' }
];

export const howItWorks = [
  {
    id: 1,
    step: '01',
    title: 'Escolha o serviço',
    description: 'Explore nossos serviços premium e encontre o ideal para você.'
  },
  {
    id: 2,
    step: '02',
    title: 'Agende seu horário',
    description: 'Reserve rapidamente pelo Gendo ou tire dúvidas via WhatsApp.'
  },
  {
    id: 3,
    step: '03',
    title: 'Viva a experiência',
    description: 'Chegue, relaxe e saia com o melhor visual da região.'
  }
];

export const team = [
  {
    id: 1,
    name: 'João Gabriel',
    specialty: 'Especialista em degradê',
    description: 'Especializado em cortes modernos e degradê de alta precisão.',
    image: 'https://customer-assets.emergentagent.com/job_barbeiros-jundiai/artifacts/36cy9d4a_DSC08685.JPG'
  },
  {
    id: 2,
    name: 'Ariel Dias',
    specialty: 'Especialista em cortes modernos',
    description: 'Barbeiro sênior especializado em transformação de imagem masculina, com foco em barba, visagismo e técnicas refinadas com navalha.',
    image: 'https://customer-assets.emergentagent.com/job_barbeiros-jundiai/artifacts/rmb4eh33_DSC08703.JPG'
  },
  {
    id: 3,
    name: 'Vinicius Santos',
    specialty: 'Cortes avançados',
    description: 'Expert em estética masculina, com domínio em design de barba e experiência clássica com navalha tradicional.',
    image: 'https://customer-assets.emergentagent.com/job_barbeiros-jundiai/artifacts/wwbyafuz_DSC08671.JPG'
  },
  {
    id: 4,
    name: 'William de Sá',
    specialty: 'Cortes e barbas',
    description: 'Especialista em barbas e cortes inovadores para todos os estilos.',
    image: 'https://customer-assets.emergentagent.com/job_barbeiros-jundiai/artifacts/8lo9ft2c_DSC08668.JPG'
  },
  {
    id: 5,
    name: 'Matheus Victório',
    specialty: 'Barbeiro Profissional',
    description: 'Profissional dedicado a entregar cortes precisos e experiências de alto padrão, com atenção total aos detalhes.',
    image: 'https://customer-assets-7cd3h4nn.emergentagent.net/job_barbeiros-jundiai/artifacts/zqt60joo_f45f1a1e-31f5-40f6-9c32-17821b26afbb.jpg'
  },
  {
    id: 6,
    name: 'Sandra Rocha',
    specialty: 'Recepção',
    description: 'Recepção de excelência e estratégia que gera resultados.',
    image: 'https://customer-assets.emergentagent.com/job_barbeiros-jundiai/artifacts/az3sw5zu_DSC08759.JPG'
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'João Pedro Costa',
    rating: 5,
    comment: 'Melhor barbearia de Jundiaí! Atendimento excepcional e ambiente top. Sempre saio satisfeito.'
  },
  {
    id: 2,
    name: 'Ricardo Almeida',
    rating: 5,
    comment: 'Profissionais de alto nível. O corte ficou perfeito e o ambiente é muito agradável. Recomendo!'
  },
  {
    id: 3,
    name: 'Marcos Vinícius',
    rating: 5,
    comment: 'Experiência incrível! Desde a recepção até o acabamento final, tudo impecável. Vale cada centavo.'
  },
  {
    id: 4,
    name: 'André Luiz',
    rating: 5,
    comment: 'A ABR é referência em Jundiaí. Barbeiros talentosos e ambiente premium. Sempre volto!'
  },
  {
    id: 5,
    name: 'Felipe Santos',
    rating: 5,
    comment: 'Atendimento de primeira! Corte perfeito e atenção aos detalhes. Melhor barbearia da região.'
  },
  {
    id: 6,
    name: 'Gabriel Rodrigues',
    rating: 5,
    comment: 'Ambiente masculino e sofisticado. Os profissionais são excelentes e o resultado sempre surpreende.'
  }
];

export const gallery = [
  'https://customer-assets.emergentagent.com/job_barbeiros-jundiai/artifacts/pmav1cpv_IMG_0499.jpeg',
  'https://customer-assets.emergentagent.com/job_barbeiros-jundiai/artifacts/zgiybiiv_IMG_0498.jpeg',
  'https://customer-assets.emergentagent.com/job_barbeiros-jundiai/artifacts/g1bnolpu_IMG_0500.jpeg',
  'https://customer-assets.emergentagent.com/job_barbeiros-jundiai/artifacts/rt06zdyr_IMG_0497.jpeg',
  'https://customer-assets.emergentagent.com/job_barbeiros-jundiai/artifacts/hdad7foe_IMG_0479.jpeg',
  'https://customer-assets.emergentagent.com/job_barbeiros-jundiai/artifacts/igxccaf8_IMG_0502.jpeg'
];

export const businessInfo = {
  name: 'ABR Barbearia',
  phone: '5511939079671',
  whatsappMessage: 'Olá, vim pelo site e gostaria de agendar um horário.',
  bookingUrl: 'https://vilu978.gendo.app/#/',
  address: {
    street: 'Av. Humberto Cereser, 523',
    neighborhood: 'Jundiaí Mirim',
    city: 'Jundiaí',
    state: 'SP',
    full: 'Av. Humberto Cereser, 523 – Jundiaí Mirim, Jundiaí - SP'
  },
  hours: {
    weekdays: 'Segunda a Sábado',
    time: '09h às 20h'
  },
  social: {
    instagram: '@abrbarbearia',
    facebook: 'ABR Barbearia'
  },
  coordinates: {
    lat: -23.1509794,
    lng: -46.8687034
  }
};